import React, { useCallback, useEffect, useRef, useState } from 'react';

const ColumnResizer = ({ 
  children, 
  minLeftWidth = 150, 
  minRightWidth = 200, 
  initialLeftWidth = 200,
  className = ''
}) => {
  const leftColRef = useRef(null);
  const wrapperRef = useRef(null);
  const [active, setActive] = useState(false);

  const handleMouseDown = () => setActive(true);
  const mouseUp = useCallback(() => setActive(false), []);

  const mouseMove = useCallback((e) => {
    if (leftColRef.current && wrapperRef.current) {
      const wrapperWidth = wrapperRef.current.offsetWidth;
      let newLeftWidth = e.clientX - leftColRef.current.offsetLeft;

      const rightWidth = wrapperWidth - newLeftWidth;

      if (newLeftWidth < minLeftWidth) newLeftWidth = minLeftWidth;
      if (rightWidth < minRightWidth) newLeftWidth = wrapperWidth - minRightWidth;

      leftColRef.current.style.width = newLeftWidth - 1 + 'px';
    }
  }, [minLeftWidth, minRightWidth]);

  useEffect(() => {
    if (active) {
      window.addEventListener('mousemove', mouseMove);
      window.addEventListener('mouseup', mouseUp);
    }

    return () => {
      window.removeEventListener('mousemove', mouseMove);
      window.removeEventListener('mouseup', mouseUp);
    };
  }, [active, mouseMove, mouseUp]);


  return (
    <div className={`column-resizer-wrapper ${className}`} ref={wrapperRef}>
      <div 
        className="left-col" 
        ref={leftColRef} 
        style={{ width: initialLeftWidth + 'px' }}
      >
        {children[0]}
      </div>
      <div 
        className="drag-handle" 
        onMouseDown={handleMouseDown}
      />
      <div
        className="right-col"
        style={{width: minRightWidth}}
      >
        {children[1]}
      </div>
      {active && <div className='resize-overlay'style={{position: 'absolute', zIndex: 4, left: 0, top: 0, bottom: 0, right: 0 }}></div>}
    </div>
  );
};

export default ColumnResizer;
